import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { additionalDetailsFields } from 'common/listingFormFields';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import ButtonDeprecated, { BUTTON_THEME_BLUE_GREYCLIFF } from 'client/components/ButtonDeprecated';

import './SrSunSetupDriverJobPage.less';

const VIEW_STATE_INPUT = 'VIEW_STATE_INPUT';
const VIEW_STATE_VALUE = 'VIEW_STATE_VALUE';

const SrSunSetupDriverJobConfirmListingInformation = ({
  formikBag,
  getFormFieldsById,
  onUpdateJob,
}) => {
  const verifyBedroomsValue = formikBag.values.details?.verifyBedrooms;
  const verifyBathroomsValue = formikBag.values.details?.verifyBathrooms;

  const [bedroomsViewState, setBedroomsViewState] = useState(
    verifyBedroomsValue ? VIEW_STATE_VALUE : VIEW_STATE_INPUT,
  );

  const [bathroomsViewState, setBathroomsViewState] = useState(
    verifyBathroomsValue ? VIEW_STATE_VALUE : VIEW_STATE_INPUT,
  );

  const _onSubmitClick = (formFieldId) => {
    const parserFn = formFieldId === 'verifyBathrooms' ? parseFloat : parseInt;
    const currentValue = formikBag.values.details
      ? parserFn(formikBag.values.details[formFieldId], 10) || null
      : null;

    onUpdateJob({
      updates: {
        details: {
          ...(formikBag.values.details || {}),
          [formFieldId]: currentValue,
        },
      },
    });

    if (!currentValue || isNaN(currentValue)) {
      return;
    }

    switch (formFieldId) {
      case 'verifyBedrooms':
        setBedroomsViewState(VIEW_STATE_VALUE);
        break;
      case 'verifyBathrooms':
        setBathroomsViewState(VIEW_STATE_VALUE);
        break;
    }
  };

  const _onEditClick = (formFieldId) => {
    switch (formFieldId) {
      case 'verifyBedrooms':
        setBedroomsViewState(VIEW_STATE_INPUT);
        break;
      case 'verifyBathrooms':
        setBathroomsViewState(VIEW_STATE_INPUT);
        break;
    }
  };

  return (
    <>
      <div styleName="card">
        <span styleName="cardTitle">Verify Number of Bedrooms</span>

        <SrBox paddingTop="8px">
          <SrText font="greycliff" fontSize="14px" weight="500" lineHeight="20px">
            Look around the property and count the number of bedrooms.
          </SrText>
        </SrBox>

        {bedroomsViewState === VIEW_STATE_INPUT && (
          <div>
            <SrFormikField
              formField={getFormFieldsById('details.verifyBedrooms')}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE_GREYCLIFF}
              onClick={() => _onSubmitClick('verifyBedrooms')}
              margin="20px 0"
            >
              Submit
            </ButtonDeprecated>
          </div>
        )}

        {bedroomsViewState === VIEW_STATE_VALUE && (
          <SrBox paddingTop="24px">
            <div styleName="jobDetailsBox" style={{ paddingBottom: '10px' }}>
              <span styleName="title">Beds</span>
              <br />
              <span styleName="bigValue">{verifyBedroomsValue}</span>
            </div>
            <SrBox margin="16px 0 0" textAlign="center">
              <SrText
                font="greycliff"
                weight="800"
                color="blue300"
                decoration="underline"
                fontSize="16px"
                cursor="pointer"
                onClick={() => _onEditClick('verifyBedrooms')}
              >
                Edit Number
              </SrText>
            </SrBox>
          </SrBox>
        )}
      </div>

      <div styleName="card">
        <span styleName="cardTitle">Verify Number of Bathrooms</span>

        <SrBox paddingTop="8px">
          <SrText font="greycliff" fontSize="14px" weight="500" lineHeight="20px">
            Look around the property and count the number of bathrooms.
          </SrText>
        </SrBox>

        {bathroomsViewState === VIEW_STATE_INPUT && (
          <div>
            <SrFormikField
              formField={getFormFieldsById('details.verifyBathrooms')}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE_GREYCLIFF}
              onClick={() => _onSubmitClick('verifyBathrooms')}
              margin="20px 0"
            >
              Submit
            </ButtonDeprecated>
          </div>
        )}

        {bathroomsViewState === VIEW_STATE_VALUE && (
          <SrBox paddingTop="24px">
            <div styleName="jobDetailsBox" style={{ paddingBottom: '10px' }}>
              <span styleName="title">Bath</span>
              <br />
              <span styleName="bigValue">{verifyBathroomsValue}</span>
            </div>
            <SrBox margin="16px 0 0" textAlign="center">
              <SrText
                font="greycliff"
                weight="800"
                color="blue300"
                decoration="underline"
                fontSize="16px"
                cursor="pointer"
                onClick={() => _onEditClick('verifyBathrooms')}
              >
                Edit Number
              </SrText>
            </SrBox>
          </SrBox>
        )}
      </div>

      <div styleName="card">
        <span styleName="cardTitle">Confirm Property Details</span>

        <SrBox paddingTop="8px">
          <SrText font="greycliff" fontSize="14px" weight="500" lineHeight="20px">
            Confirm that the appliances information provided by the partner are in the property.
          </SrText>
        </SrBox>
        {additionalDetailsFields.map((formField) => (
          <SrFormikField
            formField={getFormFieldsById(`details.${formField.id}`)}
            formikBag={formikBag}
            theme={SR_FIELD_THEME_ADOBE}
          />
        ))}
      </div>
    </>
  );
};

SrSunSetupDriverJobConfirmListingInformation.propTypes = {
  formikBag: PropTypes.object.isRequired,
  getFormFieldsById: PropTypes.func.isRequired,
  onUpdateJob: PropTypes.func.isRequired,
};

SrSunSetupDriverJobConfirmListingInformation.displayName =
  'SrSunSetupDriverJobConfirmListingInformation';

export default SrSunSetupDriverJobConfirmListingInformation;
